import React, { useEffect, useState } from "react";
import "./growthChart.scss";
import {
  ERXComponentsHeader,
  GROWTH_CHART_TILES,
  GROWTH_CHART_TILES_TITLES,
} from "../../ERXConstants/constants";
import CollapseIcon from "../../../../assets/rx_expand.svg";
import AddNewVisit from "./AddNewVisit";
import { Divider } from "@material-ui/core";
import add_icon from "../../../../assets/add_icon.svg";
import { GET_PATIENT_VITALS } from "../../ERXViewApiHandler/apiConstants";
import PatientsVisits from "./PatientsVisits";
import GrowthChartTiles from "./GrowthChartTiles";
import { GrowthChartGraph } from "./GrowthChartGraph";
import moment from "moment";
import settingIcon from "../../../../assets/settings_gear_icon.svg";
import settingIconActive from "../../../../assets/settings_gear_icon_active.svg";
import SectionSetting from "../SectionSetting";
import { getGrowthGraphDetailsIndexDB } from "./GrowthChartGraph/growthGraphIndexDB";
import { c2cPostApiHandler } from "../../../../Util/c2cApiHandler";

const GrowthChart = (props) => {
  const {
    erxComponents,
    callGrowthChartVitals,
    appointmentData,
    patientDetails,
    vitalsList,
    showEditGrowthChart,
    showSettingUi,
    toggleSections,
    handleOpenPrintChartPopup,
    settingIconClick,
    handleSetting,
    setCallGrowthChartVitals,
    fetchVitals,
    getVaccines,
    handleApiLoaders,
  } = props;

  const [openPatientVisit, setOpenPatientVisit] = useState(false);
  const [editVisit, setEditVisit] = useState(false);
  const [patientVisits, setPatientVisits] = useState([]);
  const [growthChartVitals, setGrowthChartVitals] = useState(null);
  const [growthChartTiles, setGrowthChartTiles] = useState(
    JSON.parse(JSON.stringify(GROWTH_CHART_TILES))
  );
  const [collapseGrowthTiles, setCollapseGrowthTiles] = useState(false);
  const [getZscore, setGetZscore] = useState(false);
  const [graphDetails, setGraphDetails] = useState({});

  // Lifecycle Methods ===>

  useEffect(() => {
    let indx = erxComponents.findIndex(
      (d) => d.title === ERXComponentsHeader.GROWTH_CHART
    );
    if (erxComponents[indx].expand) {
      handleGraphDetails();
      setEditVisit(showEditGrowthChart);
      getGrowthVitals();
    }
  }, [erxComponents]);

  useEffect(() => {
    handleTilesWRTAge();
  }, [growthChartVitals]);

  useEffect(() => {
    if (callGrowthChartVitals) {
      getGrowthVitals();
      setTimeout(() => {
        setCallGrowthChartVitals(false);
      }, 10);
    }
  }, [callGrowthChartVitals]);

  // <===

  // Helper Methods ===>

  const handleGraphDetails = async () => {
    let details = await getGrowthGraphDetailsIndexDB();
    setGraphDetails({ ...details });
  };

  const handleGrowthVitals = () => {
    let payload = { appointment_id: appointmentData?.appointment_id };
    vitalsList.forEach((obj) => {
      payload[`${obj.name?.toLowerCase()?.replace(" ", "_")}`] = obj.value;
      payload[`${obj.name?.toLowerCase()?.replace(" ", "_")}_unit`] = obj.unit;
    });
    payload["patient_gender"] = patientDetails?.patient_gender;
    payload["patient_age"] = patientDetails?.patient_age;
    payload["patient_dob"] = patientDetails?.patient_dob;
    payload["patientAgeInYears"] = getAgeInYears(payload);
    setGrowthChartVitals(payload);
  };

  const getWeight = (data, toKg) => {
    let value = "";
    if (data.weight && data.weight_unit.toLowerCase() === "lbs") {
      value =
        toKg === "toKg"
          ? parseFloat(Number(data.weight) * 0.453592).toFixed(2)
          : parseFloat(Number(data.weight) / 0.453592).toFixed(2);
    } else {
      value = data.weight ?? "";
    }
    return value;
  };

  const getHeight = (data, toCm) => {
    let value = "";
    if (data.height && data.height_unit.toLowerCase() === "ft’in”") {
      value =
        toCm === "toCm"
          ? parseFloat(Number(data.height) * 30.48).toFixed(2)
          : parseFloat(Number(data.height) / 30.48).toFixed(2);
    } else {
      value = data.height ?? "";
    }
    return value;
  };

  const getBmi = (data) => {
    let value = "";
    if (data.height && data.weight) {
      let weight =
        data.weight_unit.toLowerCase() === "lbs"
          ? Number(data.weight) * 0.453592
          : Number(data.weight);
      let height =
        data.height_unit.toLowerCase() === "ft’in”"
          ? Number(data.height) * 0.3048
          : Number(data.height) / 100;
      value = parseFloat(weight / Math.pow(height, 2)).toFixed(2);
    }
    return value;
  };

  const getAgeInYears = (data) => {
    let value = "";
    let dob = data?.patient_dob;
    let age = data?.patient_age;
    if (dob) {
      let startDate = moment(dob, "YYYY-MM-DD");
      let endDate = moment();
      const duration = moment.duration(endDate.diff(startDate));
      value = duration.years() + duration.months() / 12 + duration.days() / 365;
    } else if (age) {
      let years = age.split("years"),
        months = years[1].split("months"),
        days = months[1].split("days");
      value =
        Number(years[0].trim()) +
        Number(months[0].trim()) / 12 +
        Number(days[0].trim()) / 365;
    }
    return Number(Number(value).toFixed(3));
  };

  const handleTilesWRTAge = () => {
    let selected = false;
    growthChartTiles.forEach((ele) => {
      if (
        ele.title === GROWTH_CHART_TILES_TITLES.HC_FOR_AGE ||
        ele.title === GROWTH_CHART_TILES_TITLES.MUAC_FOR_AGE
      ) {
        ele.show = growthChartVitals?.patientAgeInYears <= 2;
        if (!ele.show && !selected) {
          selected = ele.selected;
        }

        if (!ele.show && ele.selected) {
          ele.selected = false;
        }
      }
    });
    if (selected) {
      growthChartTiles[0].selected = true;
    }
    setGrowthChartTiles([...growthChartTiles]);
    setTimeout(() => {
      setGetZscore(true);
    }, 10);
  };

  const getTilesZscore = (data) => {
    setGrowthChartTiles([...data]);
    setGetZscore(false);
  };

  // <===

  // API Calls ===>

  const getGrowthVitals = () => {
    let payload = {
      appointment_id: appointmentData?.appointment_id,
      pediatric: true,
    };

    c2cPostApiHandler(GET_PATIENT_VITALS, payload).then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          let finalData = [],
            pageNo = 1,
            newdata = [];
          if (res.data.data.length > 0) {
            let temp = res.data.data[0];
            if (
              temp?.weight ||
              temp?.height ||
              temp?.head_circumference ||
              temp.bmi
            ) {
              newdata.push(res.data.data[0]);
            }
          }
          if (res.data.past_visits.length > 0) {
            newdata = [...newdata, ...res.data.past_visits];
          }
          while (newdata.length > 0) {
            let spliceData = newdata.splice(0, Number(5));
            spliceData.forEach((sp) => {
              sp.pageNo = pageNo;
              sp.selected = false;
              sp.weight = getWeight(sp, "toKg");
              sp.weight_unit = "Kg";
              sp.height = getHeight(sp, "toCm");
              sp.height_unit = "Cm";
              sp.bmi = getBmi(sp);
              sp.patientAgeInYears = getAgeInYears(sp);
            });
            finalData.push(...spliceData);
            pageNo += 1;
          }

          setPatientVisits(finalData);
          if (res.data.data.length > 0) {
            setGrowthChartVitals({
              ...res.data.data[0],
              patientAgeInYears: getAgeInYears(res.data.data[0]),
            });
          } else {
            handleGrowthVitals();
          }
        } else {
          handleGrowthVitals();
        }
      } else {
        handleGrowthVitals();
      }
    });
  };

  // <===

  // Actions ===>

  const handleNewVisit = () => {
    let selectedVitals = patientVisits.filter((d) => d.selected);
    if (selectedVitals?.length > 0 && !editVisit) {
      getGrowthVitals();
    } else {
      setEditVisit(true);
      setOpenPatientVisit(true);
      getGrowthVitals();
    }
  };

  const handleCloseVisit = () => {
    setOpenPatientVisit(false);
  };

  const handleSelectVisit = (data) => {
    patientVisits.map((e) => (e.selected = false));
    let index = patientVisits.findIndex((d) => d.id === data.id);
    if (index > -1) {
      patientVisits[index].selected = true;
    }
    setPatientVisits([...patientVisits]);
    setGrowthChartVitals(data);
    setOpenPatientVisit(true);
  };

  const handleTileSelection = (item) => {
    let ind = growthChartTiles.findIndex((ele) => ele.id === item.id);
    growthChartTiles.forEach((ele) => {
      ele.selected = false;
    });
    growthChartTiles[ind].selected = true;
    setGrowthChartTiles([...growthChartTiles]);
  };

  const toggleGrowthTiles = () => {
    setCollapseGrowthTiles(!collapseGrowthTiles);
  };

  // <===

  // Display UI ===>

  const displayGrowthChart = () => {
    let growthChart = erxComponents.filter(
      (ele) => ele.title === ERXComponentsHeader.GROWTH_CHART
    );
    let index = erxComponents.findIndex(
      (ele) => ele.title === ERXComponentsHeader.GROWTH_CHART
    );
    let comp = growthChart[0];
    return (
      <div className="">
        <div className="erx-main-section-header-cont">
          <div
            className="growth-chart-header-wrapper"
            onClick={() => toggleSections(comp)}
          >
            {comp.title}
          </div>
          <img
            src={
              showSettingUi && showSettingUi === comp.id
                ? settingIconActive
                : settingIcon
            }
            alt=""
            style={{ height: "19px" }}
            className="erx-main-section-header-arrow mr-2"
            onClick={() => {
              if (showSettingUi === comp.id) {
                settingIconClick(0);
              } else {
                settingIconClick(comp.id);
              }
            }}
          ></img>
          <img
            src={CollapseIcon}
            alt=""
            onClick={() => toggleSections(comp)}
            className={
              "erx-main-section-header-arrow " +
              (comp.expand
                ? "erx-main-section-header-up-arrow"
                : "erx-main-section-header-down-arrow")
            }
          />
        </div>
        {comp.expand && (
          <div className="erx-main-section-content">
            {comp.id === showSettingUi ? (
              <SectionSetting
                id={comp.id}
                setting={comp.settings}
                handleSetting={(ques, ans) => handleSetting(ques, ans, index)}
              />
            ) : (
              displayGrowthChartContent()
            )}
          </div>
        )}
      </div>
    );
  };

  const displayGrowthChartContent = () => {
    return (
      <>
        <div
          className="graph-chart-and-tiles-wrapper"
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          {displayGrowthGraph()}
          {displayChartTiles()}
        </div>
        {displayPatientVisits()}
      </>
    );
  };

  const displayGrowthGraph = () => {
    return (
      <div>
        <GrowthChartGraph
          graphDetails={graphDetails}
          growthChartTiles={growthChartTiles}
          patientVisits={patientVisits}
          getZscore={getZscore}
          getTilesZscore={getTilesZscore}
        />
      </div>
    );
  };

  const displayChartTiles = () => {
    return (
      <div>
        {window.innerWidth < 767 && (
          <div className="d-flex ai-center" style={{ marginBottom: "10px" }}>
            <div className="growth-chart-tiles-charts-header">
              Types of Charts
            </div>
            <img
              src={CollapseIcon}
              alt=""
              onClick={() => toggleGrowthTiles()}
              className={
                "erx-main-section-header-arrow " +
                (!collapseGrowthTiles
                  ? "erx-main-section-header-up-arrow"
                  : "erx-main-section-header-down-arrow")
              }
              style={{ width: "12px", height: "7px" }}
            />
          </div>
        )}
        {!collapseGrowthTiles && (
          <div className="chart-tiles-cont">
            {growthChartTiles.map(
              (item) =>
                item.show && (
                  <div key={item.id} className="chart-tiles">
                    <GrowthChartTiles
                      title={item.title}
                      subtitle={item.zScore ? item.subtitle + item.zScore : ""}
                      selected={item.selected}
                      handleTileSelection={() => handleTileSelection(item)}
                    />
                  </div>
                )
            )}
          </div>
        )}
      </div>
    );
  };

  const displayPatientVisits = () => {
    return (
      <div>
        <div className="growth-chart-patient-visits-header">
          <div className="growth-chart-patient-visits-text">
            Patients Visits
          </div>
          <div
            className="growth-chart-add-edit-visits-text"
            onClick={handleNewVisit}
          >
            {editVisit ? (
              "Edit Details"
            ) : (
              <span className="d-flex ai-center">
                <img src={add_icon} alt="" style={{ marginRight: "10px" }} />
                Add New Visit
              </span>
            )}
          </div>
        </div>
        <PatientsVisits
          patientVisits={patientVisits}
          growthChartVitals={growthChartVitals}
          handleSelectVisit={handleSelectVisit}
        />
        {openPatientVisit && (
          <>
            <Divider style={{ marginBottom: "15px" }} />
            <AddNewVisit
              growthChartVitals={growthChartVitals}
              patientDetails={patientDetails}
              appointmentData={appointmentData}
              handleApiLoaders={handleApiLoaders}
              handleCloseVisit={handleCloseVisit}
              handleOpenPrintChartPopup={handleOpenPrintChartPopup}
              fetchVitals={fetchVitals}
              getVaccines={getVaccines}
            />
          </>
        )}
      </div>
    );
  };

  // <===

  return (
    <div
      className="growth-chart-erx-main"
      style={{
        paddingBottom: window.innerWidth < 767 ? "0" : "",
      }}
    >
      {displayGrowthChart()}
    </div>
  );
};

export default GrowthChart;
